import { render, staticRenderFns } from "./TripInclusions.vue?vue&type=template&id=46ec594a&scoped=true&"
import script from "./TripInclusions.vue?vue&type=script&lang=js&"
export * from "./TripInclusions.vue?vue&type=script&lang=js&"
import style0 from "./TripInclusions.vue?vue&type=style&index=0&id=46ec594a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ec594a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46ec594a')) {
      api.createRecord('46ec594a', component.options)
    } else {
      api.reload('46ec594a', component.options)
    }
    module.hot.accept("./TripInclusions.vue?vue&type=template&id=46ec594a&scoped=true&", function () {
      api.rerender('46ec594a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/TripInclusions.vue"
export default component.exports